@use 'shared/styles/generated/tokens' as *;

.root {
  display: flex;
  flex-direction: column;
  gap: $space-small-m;
}

.chip {
  flex: 1;
  min-width: 0;
}
